import React, { Suspense, useEffect } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Container, Spinner } from '@probatix/common/components/atoms'
import { isLocaleSupported } from '@probatix/common/utils/data'

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'

const ShellView: React.FC = () => {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const { locale } = useParams()
  const { pathname, search } = useLocation()

  useEffect(() => {
    // TODO: v6 does not support regex https://reactrouter.com/en/main/upgrading/v5#note-on-route-path-patterns
    const urlLocale = locale || i18n.language
    if (!isLocaleSupported(urlLocale)) {
      return navigate(`/${i18n.language}${pathname}${search}`)
    }
  }, [])

  return (
    <ErrorBoundary>
      <Suspense fallback={<Container><Spinner /></Container>}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  )
}

export default ShellView
